import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Helmet from "react-helmet"

import MainAppChrome from "../../chrome/MainAppChrome"
import Hero from "../../../components/ui-Hero"
import PageSection from "../../../components/ui-PageSection"
import Divider from "ui-Divider"
import { Container } from "ui-Grid"
import { Headline, Text, Copy } from "ui-Text"

const styleSheet = _theme => ({
  map: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
  },
})

function Contact({ classes }) {
  return (
    <MainAppChrome>
      <Helmet>
        <title>Contact JA Lactation Support</title>
      </Helmet>
      <Hero>
        <iframe
          title="map"
          className={classes.map}
          frameBorder={0}
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBoO-7FF1ybguzYbhO6BBz6tf-LQyPfKH8&q=JA+Lactation+Support,Temecula+CA"
        />
      </Hero>
      <PageSection>
        <Container wide>
          <Copy>
            <Headline paragraph>Mailing Address</Headline>
            <Text paragraph={false}>42274 Faber Ct </Text>
            <Text paragraph={false}>Temecula, CA 92592</Text>
          </Copy>
          <Divider gutterTop gutterBottom />
          <Copy>
            <Headline paragraph>Other</Headline>
            <Text paragraph>
              <a href="mailto:julie@jalactation.com">julie@jalactation.com</a>
            </Text>
            <Text paragraph>
              <a href="tel:9515266870">951-526-6870</a>
            </Text>
          </Copy>
        </Container>
      </PageSection>
    </MainAppChrome>
  )
}

export default withStyles(styleSheet)(Contact)



// WEBPACK FOOTER //
// ./src/views/pages/Contact/index.js